import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Clock } from 'lucide-react';
const WHATSAPP_URL = 'https://wa.me/26774833041?text=Hello%20De%20Rien%20Cash%20Loan%2C%20I%20would%20like%20assistance%20with%20a%20loan%20application.';
export function WhatsAppButton() {
  const [showPopup, setShowPopup] = useState(false);
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    // Delay initial appearance for polish
    const timer = setTimeout(() => setMounted(true), 1200);
    return () => clearTimeout(timer);
  }, []);
  return <AnimatePresence data-id="element-517">
      {mounted && <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3" data-id="element-518">
          {/* Popup Card */}
          <AnimatePresence data-id="element-519">
            {showPopup && <motion.div initial={{
          opacity: 0,
          y: 8,
          scale: 0.95
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 8,
          scale: 0.95
        }} transition={{
          duration: 0.2,
          ease: 'easeOut'
        }} className="bg-white rounded-2xl shadow-xl border border-gray-100 p-4 w-64 relative" data-id="element-520">
                {/* Close */}
                <button onClick={() => setShowPopup(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors" aria-label="Close" data-id="element-521">
                  <X size={14} data-id="element-522" />
                </button>

                {/* Header */}
                <div className="flex items-center gap-2 mb-2" data-id="element-523">
                  <div className="w-8 h-8 rounded-full bg-[#25D366] flex items-center justify-center flex-shrink-0" data-id="element-524">
                    <svg viewBox="0 0 24 24" className="w-4 h-4 fill-white" data-id="element-525">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-526" />
                    </svg>
                  </div>
                  <div data-id="element-527">
                    <p className="text-xs font-bold text-gray-800" data-id="element-528">
                      De Rien Cash Loan
                    </p>
                    <p className="text-[10px] text-[#25D366] font-medium" data-id="element-529">
                      ● Online
                    </p>
                  </div>
                </div>

                {/* Message */}
                <p className="text-xs text-gray-600 leading-relaxed mb-3" data-id="element-530">
                  Need help? Chat with us on WhatsApp — response within 24
                  hours.
                </p>

                {/* Hours */}
                <div className="bg-gray-50 rounded-lg p-2 mb-3 flex items-start gap-1.5" data-id="element-531">
                  <Clock className="h-3 w-3 text-[#25D366] mt-0.5 flex-shrink-0" data-id="element-532" />
                  <div className="text-[10px] text-gray-500 leading-relaxed" data-id="element-533">
                    <p data-id="element-534">
                      <span className="font-semibold text-gray-700" data-id="element-535">
                        Mon – Fri:
                      </span>{' '}
                      8:00 AM – 5:00 PM
                    </p>
                    <p data-id="element-536">
                      <span className="font-semibold text-gray-700" data-id="element-537">Sat:</span>{' '}
                      9:00 AM – 1:00 PM
                    </p>
                  </div>
                </div>

                {/* CTA */}
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="block w-full text-center bg-[#25D366] hover:bg-[#1ebe5d] text-white text-xs font-bold py-2 rounded-lg transition-colors duration-200" data-id="element-538">
                  Start Chat
                </a>

                {/* Arrow */}
                <div className="absolute -bottom-2 right-6 w-4 h-4 bg-white border-r border-b border-gray-100 rotate-45" data-id="element-539" />
              </motion.div>}
          </AnimatePresence>

          {/* WhatsApp Button */}
          <motion.button onClick={() => setShowPopup(!showPopup)} whileHover={{
        scale: 1.08
      }} whileTap={{
        scale: 0.95
      }} className="w-14 h-14 rounded-full bg-[#25D366] shadow-lg hover:shadow-xl flex items-center justify-center transition-shadow duration-200 relative" aria-label="Chat on WhatsApp" data-id="element-540">
            <svg viewBox="0 0 24 24" className="w-7 h-7 fill-white" data-id="element-541">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" data-id="element-542" />
            </svg>
            {/* Pulse ring */}
            <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20" data-id="element-543" />
          </motion.button>
        </motion.div>}
    </AnimatePresence>;
}